import {Injectable} from '@angular/core';
import {DataStoreService} from './data-store.service';
import {Folder, IRawFolder} from './folder';
import {KitService} from './kit.service';
import {Kit} from './kit';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {Element} from './element';
import {Http} from '@angular/http';
import {environment} from '../../environments/environment';
import {extractData} from './utils';

@Injectable()
export class FolderService extends DataStoreService<Folder> {

  // an array indexed by folder id (integer)
  _kitFolderMap$ = new BehaviorSubject<Folder[][]>([]);

  constructor(private kitService: KitService, private http: Http) {
    super();
    this.kitService.updates$().subscribe((kit: Kit) => this.collectFolders(kit));
    this.kitService.inserts$().subscribe((kit: Kit) => {
      this.collectFolders(kit);
    });
  }

  createFolder(kit: Kit, name: string): Observable<Folder> {
    return this.http.post(`${environment.apiUrl}/admin/folders`, {name: name, kit_id: kit.id})
      .map(extractData)
      .map((rawFolder: IRawFolder) => {
        return new Folder(rawFolder.id, rawFolder.name, kit.id, []);
      })
      .do((folder: Folder) => {
        super.insert(folder.id, folder);
      });
  }

  collectElements(element: Element) {

    let folderId = element.folder_id;
    let folder = this.find(folderId);

    if (folder) {

      let folderElements = [];
      folder.elements.forEach((element) => {
        folderElements[element.id] = element;
      });

      if (!folderElements[element.id]) {
        this.update(folder, {elements: [element]});
      }
    }
  }

  folderKitMap$(): Observable<Folder[][]> {
    return this._kitFolderMap$.asObservable();
  }

  collectFolders(kit: Kit) {

    kit.folders.forEach((folder: Folder) => {
      if (!this.find(folder.id)) {
        this.insert(folder.id, folder);
        this.addFolderToKit(folder, kit);
      }
    });

    kit.elements.forEach((element: Element) => {
      this.collectElements(element);
    });

  }

  getFoldersForKit(kit: Kit): Folder[] {
    let map = this._kitFolderMap$.getValue();
    return map[kit.id] ? map[kit.id] : [];
  }

  addFolderToKit(folder: Folder, kit: Kit) {
    let folderMap = this._kitFolderMap$.getValue();
    if (folderMap[folder.id]) {
      folderMap[kit.id].push(folder);
    } else {
      folderMap[kit.id] = [folder];
    }
    this._kitFolderMap$.next(folderMap);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/folder.service.ts